var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moreSeparator clearfix"},[_c('div',{staticClass:"moreSeparatorBox",on:{"click":_vm.moreClick}},[_c('span',{class:_vm.klass}),_c('span',{staticClass:"moreLable"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42ce5a7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/select/MoreSeparator.vue
// module id = null
// module chunks = 